import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";

export function DashboardTab({ settings, updateSetting }) {
  const widgets = [
    { key: "showStudentCount", label: "Student Count", desc: "Total enrolled students" },
    { key: "showAttendanceToday", label: "Attendance Today", desc: "Present, absent, tardy counts" },
    { key: "showRoster", label: "Daily Roster", desc: "Today's student schedule" },
    { key: "showPlanReviews", label: "Plan Reviews Due", desc: "Clinical plans needing review" },
    { key: "showQuickActions", label: "Quick Actions", desc: "Shortcuts for common tasks" },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Dashboard Widgets</CardTitle>
          <CardDescription>Choose which cards to show on your dashboard</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {widgets.map((w) => (
              <div key={w.key} className="flex items-center justify-between p-4 border rounded-lg">
                <div className="space-y-1">
                  <Label className="font-medium">{w.label}</Label>
                  <p className="text-sm text-muted-foreground">{w.desc}</p>
                </div>
                <Switch checked={settings[w.key]} onCheckedChange={(checked) => updateSetting(w.key, checked)} data-testid={`toggle-${w.key.replace(/([A-Z])/g, '-$1').toLowerCase()}`} />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
